module.exports = __webpack_public_path__ + "db58a090c126455232ea91c5814eec0e.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/6.png
// module id = 304
// module chunks = 0